// Service Worker 注册插件（仅客户端）
// 在生产环境注册 SW，实现静态资源离线缓存
export default defineNuxtPlugin(() => {
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // 注册失败静默处理，不影响主功能
    })
  }
})
